<template>
  <div class="party-banner">
    <img :src="mobilepartyBanner" alt="" />
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilepartyBanner from "../../../assets/party/mobilepartyBanner.png";

export default {
  setup() {
    return reactive({
      mobilepartyBanner: mobilepartyBanner,
    });
  },
};
</script>

<style scoped>
.party-banner img {
  width: 100%;
  height: 160px;
}
</style>
